import { PlansListPage } from "@/components/plans/PlansListPage";

export function DashboardPlansPage() {
  return <PlansListPage />;
}
